'use client';

import { Accordion, AccordionItem } from '@/components/ui/Accordion';
import { ComponentLocationProps } from '@/types/components';
import { useEffect, useState } from 'react';
import { Clinic } from './Clinic';

interface LocationsAccordionProps {
  locationProps: ComponentLocationProps[];
  accordionId: string;
}

export function LocationsAccordion({
  locationProps,
  accordionId,
}: LocationsAccordionProps) {
  const [hash, setHash] = useState('');

  useEffect(() => {
    // Set initial hash on mount and handle hash changes
    const updateHash = () => {
      setHash(window.location.hash.slice(1));
    };

    // Set initial hash
    updateHash();

    // Handle hash changes
    window.addEventListener('hashchange', updateHash);
    return () => window.removeEventListener('hashchange', updateHash);
  }, []);

  useEffect(() => {
    if (!hash) return;

    // Find the matching location
    const matchingLocation = locationProps.find(
      location => location.slug === hash
    );

    if (matchingLocation) {
      // Small delay to ensure DOM has updated
      setTimeout(() => {
        const element = document.querySelector(
          `[data-accordion-value="${matchingLocation.label}"]`
        );
        if (element) {
          const headerOffset = 80; // Adjust based on your header height
          const elementPosition = element.getBoundingClientRect().top;
          const offsetPosition =
            elementPosition + window.pageYOffset - headerOffset;

          window.scrollTo({
            top: offsetPosition,
          });
        }
      }, 100);
    }
  }, [hash, locationProps]);

  return (
    <Accordion id={accordionId}>
      {locationProps.map((location: ComponentLocationProps) => {
        const shouldBeOpen = hash === location.slug;

        return (
          <AccordionItem
            key={location.label}
            value={location.label}
            heading={location.label}
            open={shouldBeOpen}
            backgroundColor='bg-sh-cream'
            innerBackgroundColor='bg-sh-paper'
          >
            {Array.isArray(location.clinics) && (
              <div className='grid grid-cols-1 gap-4 xl:grid-cols-2 2xl:grid-cols-3'>
                {location.clinics.map(locationClinic => (
                  <Clinic key={locationClinic.id} {...locationClinic} />
                ))}
              </div>
            )}
          </AccordionItem>
        );
      })}
    </Accordion>
  );
}
